<template>
  <div v-if="articles.length > 0" class="similar-articles-container mt-4">
    <h4 class="mb-3">{{ title() }}</h4>
    <div class="articles-scroll-list">
      <RecipeCardPopular
        v-for="article in articles"
        :key="article.id"
        :recipe="article"
        @show-full-recipe="handleShowFullArticle"
      />
    </div>
  </div>
  <div v-else-if="isLoading" class="text-center mt-4">
    <div class="spinner-border text-secondary" role="status">
      <span class="visually-hidden">Загрузка...</span>
    </div>
  </div>
</template>

<script>
import RecipeCardPopular from "./RecipeCardPopular.vue";

export default {
  name: "SimilarArticles",
  components: {
    RecipeCardPopular,
  },
  props: {
    excludeId: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    articletype: {
      type: String,
      required: false,
      default: "article",
    },
  },
  data() {
    return {
      articles: [],
      isLoading: false,
      error: null,
    };
  },
  watch: {
    excludeId: {
      immediate: true,
      handler() {
        // We can fetch even if newId is 0 (for the main page)
        this.fetchSimilarArticles();
      },
    },
  },
  methods: {
    async fetchSimilarArticles() {
      this.isLoading = true;
      this.error = null;
      this.articles = [];
      try {
        const limit = 4;
        const command = `article.getRandom/${limit}/${this.excludeId || 0}/${
          this.articletype
        }`;
        const response = await this.sendCmd(command);
        const parsedResponse = JSON.parse(response);
        const unpackedJsonString = await this.unpackData(parsedResponse.data);
        this.articles = JSON.parse(unpackedJsonString);
      } catch (err) {
        this.error = "Не удалось загрузить другие истории.";
        console.error("Error fetching similar articles:", err);
      } finally {
        this.isLoading = false;
      }
    },

    handleShowFullArticle(recipe) {
      window.location.hash = `/article/${recipe.articleid}`;
    },

    title() {
      switch (this.articletype) {
        case "article":
          return "Другие истории";
        case "recipe_of_the_day":
          return "Другие рецепты дня";
        default:
          return "Другие статьи";
      }
    },
  },
};
</script>

<style scoped>
.similar-articles-container {
  padding-top: 1rem;
  border-top: 1px solid var(--bs-border-color-translucent);
}
.articles-scroll-list {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 1rem; /* For scrollbar visibility */
  scrollbar-width: thin;
  scrollbar-color: var(--bs-secondary-bg) var(--bs-body-bg);
}

.articles-scroll-list .recipe-card-popular {
  width: 186px;
}
.articles-scroll-list .recipe-card-popular img {
  width: 186px;
  height: 186px;
}
</style>
